/**
 * Created by tdunham on 6/27/2017.
 */

import {NgModule}                   from '@angular/core';
import {ReactiveFormsModule}        from "@angular/forms";
import {RouterModule, Routes}       from '@angular/router';

import {ArticlesComponent}          from './articles.component';
import {CanDeactivateGuard}         from "../services/miscellaneous/can-deactivate-component";
import {InactivesComponent}         from "./inactives/inactives.component";
import {ItemComponent}              from "./item/item.component";
import {ListComponent}              from "./list/list.component";
import {NewsComponent}              from "./feed/news/news.component";
import {NewsResolve}                from "../services/news/news.resolve";
import {OnlyLoggedInGuard}          from "../services/miscellaneous/only-logged-in.guard";
import {RssmanagerComponent}        from "./feed/rssmanager/rssmanager.component";
import {SportResolve}               from "../services/sport/sports.resolve";
import {SuperUserGuard}             from "../services/miscellaneous/super-user.guard";
import {UserManagerComponent}       from "../admin/users/user-manager.component";
import {UserResolve}                from "../services/user/user.resolve";
import {VersionComponent}           from "./version/version.component";
import {UserReportingComponent} from "../admin/users/user-reporting.component";
import {MassrosterComponent} from './massroster/massroster.component';



const articleRoutes: Routes = [
	{
		path: 'articles',
		component: ArticlesComponent,
		canActivate: [OnlyLoggedInGuard],
		children: [
			{
				path: 'inactives',
				component: InactivesComponent,
			},
			{
				path: 'version/:id',
				component: VersionComponent,
				resolve: {
					sports: SportResolve,
					users: UserResolve,
				},
				runGuardsAndResolvers: 'paramsChange',
			},
			{
				path: 'item/:id',
				component: ItemComponent,
				canDeactivate: [CanDeactivateGuard],
				resolve: {
					article: NewsResolve,
					sports: SportResolve,
				},
				runGuardsAndResolvers: 'paramsChange',
			},
			{
				path: 'item/new',
				component: ItemComponent,
				canDeactivate: [CanDeactivateGuard],
				resolve: {
					sports: SportResolve,
				},
				runGuardsAndResolvers: 'paramsChange',
			},
			{
				path: 'list',
				component: ListComponent,
				resolve: {
					users: UserResolve,
				},
			},
			{
				path: 'news',
				component: NewsComponent,
			},
			{
				path: 'rssmanager',
				component: RssmanagerComponent,
				canActivate: [SuperUserGuard],
			},
			{
				path: 'users',
				component: UserManagerComponent,
				canActivate: [SuperUserGuard],
			},
			{
				path: 'reporting',
				component: UserReportingComponent,
				canActivate: [SuperUserGuard],
			},
      {
        path: 'massroster',
        component: MassrosterComponent
      }
		]
	},
];



@NgModule({
	imports: [
		ReactiveFormsModule,
		RouterModule.forChild(articleRoutes)
	],
	exports: [
		ReactiveFormsModule,
		RouterModule
	],
	providers: [
		NewsResolve,
		SportResolve,
	]
})


export class ArticlesRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/articles/articles.routing.module.ts